import { Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";

export default function RootModal({
  children,
  className = "max-w-md p-10",
  open,
  handleClose,
  title,
  titleClassName = "text-body-xl font-semibold",
  subTitle,
  subTitleClassName = "text-body-md",
  headClassName = "",
  showAdd = false,
  addAction = () => {},
  addText = "",
}) {
  return (
    <Transition
      enter="transition duration-300 ease-out"
      enterFrom="transform scale-100 opacity-0"
      enterTo="transform scale-100 opacity-100"
      leave="transition duration-300 ease-out"
      leaveFrom="transform scale-300 opacity-100"
      leaveTo="transform scale-100 opacity-0"
      className={"fixed  top-0 left-0 w-full h-screen z-50 "}
      show={open}
    >
      <div
        className="fixed inset-0 bg-black/10 z-[1] shr "
        onClick={handleClose}
        aria-hidden="true"
      />
      <Transition.Child
        enter="transition duration-300 ease-out"
        enterFrom="transform scale-95 opacity-0"
        enterTo="transform scale-100 opacity-100"
        leave="transition duration-300 ease-out"
        leaveFrom="transform scale-300 opacity-100"
        leaveTo="transform scale-95 opacity-0"
        className={`bg-white z-[2] max-h-[800px] flex flex-col gap-6 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 rounded-[10px] w-[512px] min-w-[512px] shadow-xl overflow-visible ${className}`}
      >
        <div>
          <div
            className={`flex flex-row justify-center gap-4 px-8 pt-4 pb-4 rounded-b-none rounded-[4px] ${headClassName}`}
          >
            <div className="flex flex-col justify-center items-center mt-4">
              {subTitle !== "" && (
                <p
                  className={`text-start text-gray-900 m-0 ${subTitleClassName}`}
                >
                  {subTitle}
                </p>
              )}
              <h3
                className={`text-body-xl text-gray-800 font-semibold ${titleClassName}`}
              >
                {title}
              </h3>
            </div>

            <div className="flex items-center absolute top-5 right-6">
              <button
                className="flex items-center justify-center p-1.5 transition-all rounded-full max-w-8 cursor-pointer right-4 top-3 bg-blue-200 hover:bg-REELTeal hover:text-white text-teal-300"
                onClick={handleClose}
              >
                <span className="sr-only">Close panel</span>
                <XMarkIcon
                  className="w-5 h-5 m-auto"
                  strokeWidth="2"
                  aria-hidden="true"
                />
              </button>
            </div>
          </div>
          <p className="border-t border-gray-200 mx-8" />
        </div>
        {showAdd && (
          <div className="justify-end items-end flex px-8">
            <button
              className="disabled:opacity-40 h-5 w-auto rounded-full bg-REELTeal border-REELTeal hover:bg-teal-200 text-white inline-flex border transition-all duration-300 items-center font-semibold justify-end p-5"
              onClick={() => addAction()}
            >
              {addText}
            </button>
          </div>
        )}
        {children}
      </Transition.Child>
    </Transition>
  );
}
